var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSedanBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.86,
    height: 62.158,
    viewBox: "0 0 119.86 62.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sedan-blue-icon",
    transform: "translate(-69.07 -450.842)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SEDAN",
    transform: "translate(104 509)",
    fill: "#04a8e8",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEDAN")), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(-1332.974 -1847.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M1433.244,2332.684c-.721-1.593-.177-3.144-.2-4.657-.116-6.762-5.155-11.957-11.66-11.924a11.865,11.865,0,0,0-11.577,11.755c-.054,1.538,1.07,3.792-2.045,3.839-2.651.041-4.808-.346-5.449-3.51a12.349,12.349,0,0,1,9.244-14.719,160.13,160.13,0,0,1,20.549-3.646c3.811-.352,6.87-2.317,10.069-4,7.177-3.774,14.4-7.291,22.754-7.545a197.868,197.868,0,0,1,20.182.3c5.063.365,9.608,2.611,13.91,5.058a48.991,48.991,0,0,0,15.091,5.646c4.9.948,5.466,1.957,5.829,6.924.182,2.463.144,4.851,1.329,7.318,1.83,3.808-.457,7.144-4.647,7.787-.438.067-.874.147-1.313.2-5.068.614-5.068.613-5.346-4.31a11.634,11.634,0,0,0-11.818-11.072,11.783,11.783,0,0,0-11.365,11.915c-.025,5.008-.025,5.013-4.883,5.016q-22.558.02-45.115.032A8.025,8.025,0,0,1,1433.244,2332.684Zm56.56-22.126c1.29,0,2.389-.069,3.476.015,1.759.136,2.564-.8,3.106-2.325.667-1.882-.833-2.327-1.889-2.944a31.965,31.965,0,0,0-19.369-4.651c-1.075.1-2.022.181-2.217,1.448-.46,3.007-1.148,6-.907,8.887h15.44c1.331-1.612.386-3.332,1.78-4.533C1489.421,2307.856,1489.588,2309.036,1489.8,2310.558Zm-19.957-9.668c-9.543-.868-17.638,2.01-25.765,7.8,3.081.07,4.366,1.228,4.2,2.983,6.141,0,12.075-.016,18.01.01,1.567.007,2.111-.9,2.3-2.245C1468.983,2306.724,1469.387,2304.015,1469.846,2300.889Z",
    transform: "translate(0)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M1413.823,2330.428a8.791,8.791,0,0,1,8.911-9.015,8.962,8.962,0,0,1,8.972,8.731c.1,5.4-3.6,8.936-9.448,9.051C1417.827,2339.281,1413.946,2335.248,1413.823,2330.428Z",
    transform: "translate(-1.341 -2.649)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M1509.861,2339.021c-5.54-.037-9.308-3.666-9.208-8.866a9.13,9.13,0,0,1,9.052-8.738,9.023,9.023,0,0,1,8.869,9.229A8.431,8.431,0,0,1,1509.861,2339.021Z",
    transform: "translate(-11.229 -2.649)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanBlueIcon);
export default __webpack_public_path__ + "static/media/sedan-blue-icon.b71ad1da3fa4912a2004affe9fb957ef.svg";
export { ForwardRef as ReactComponent };